import { routes as cvReimportRoutes } from './pages/cv-reimport/routes';
import { routes as dashboardRoutes } from './pages/dashboard/routes';
import { routes as biDashboardRoutes } from './pages/dashboard-business-intelligence/routes';
import { routes as featuredLearningOpportunitiesRoutes } from './pages/featured-learning-opportunities/routes';
import { routes as jobsRoutes } from './pages/job-details/routes';
import { routes as jobListRoutes } from './pages/job-list/routes';
import { routes as jobsPostingRoutes } from './pages/job-postings/routes';
import { routes as jobProfileRoutes } from './pages/job-profiles/routes';
import { routes as jobRecommendationsRoutes } from './pages/job-recommendations/routes';
import { routes as learningOpportunitiesRoutes } from './pages/learning-opportunities/routes';
import { routes as learningOpportunityRecommendationsByAmbitionRoutes } from './pages/learning-opportunity-recommendations-by-ambition/routes';
import { routes as learningOpportunityRecommendationsBySkillIdsRoutes } from './pages/learning-opportunity-recommendations-by-skill-ids/routes';
import { routes as myGrowthRoute } from './pages/my-growth/routes';
import { routes as profileRoutes } from './pages/profile/routes';
import { routes as settingsRoutes } from './pages/settings/routes';
import { routes as skillDetailsRoutes } from './pages/skill-details/routes';
import { routes as editAboutMeRoutes } from './pages/user-edit-about-me/routes';
import { routes as editAmbitionsRoutes } from './pages/user-edit-ambitions/routes';
import { routes as certificateRoutes } from './pages/user-edit-certificates/routes';
import { routes as editContactDetailsRoutes } from './pages/user-edit-contact-details/routes';
import { routes as courseHistoryRoutes } from './pages/user-edit-course-history/routes';
import { routes as educationHistoryRoutes } from './pages/user-edit-education-history/routes';
import { routes as editLanguagesRoutes } from './pages/user-edit-languages/routes';
import { routes as editPersonalInformationRoutes } from './pages/user-edit-personal-information/routes';
import { routes as editProfileDetailsRoutes } from './pages/user-edit-profile-details/routes';
import { routes as projectsHistoryRoutes } from './pages/user-edit-projects-history/routes';
import { routes as publicationHistoryRoutes } from './pages/user-edit-publication-history/routes';
import { routes as editSkillsRoutes } from './pages/user-edit-skills/routes';
import { routes as workHistoryRoutes } from './pages/user-edit-work-history/routes';
import type { RouteDefinition } from './route';

export const lazyRoutesConfig: readonly RouteDefinition[] = [
    ...biDashboardRoutes,
    ...certificateRoutes,
    ...courseHistoryRoutes,
    ...cvReimportRoutes,
    ...dashboardRoutes,
    ...editAboutMeRoutes,
    ...editAmbitionsRoutes,
    ...editContactDetailsRoutes,
    ...editLanguagesRoutes,
    ...editPersonalInformationRoutes,
    ...editProfileDetailsRoutes,
    ...editSkillsRoutes,
    ...educationHistoryRoutes,
    ...featuredLearningOpportunitiesRoutes,
    ...jobListRoutes,
    ...jobProfileRoutes,
    ...jobRecommendationsRoutes,
    ...jobsPostingRoutes,
    ...jobsRoutes,
    ...learningOpportunitiesRoutes,
    ...learningOpportunityRecommendationsByAmbitionRoutes,
    ...learningOpportunityRecommendationsBySkillIdsRoutes,
    ...myGrowthRoute,
    ...profileRoutes,
    ...projectsHistoryRoutes,
    ...publicationHistoryRoutes,
    ...settingsRoutes,
    ...skillDetailsRoutes,
    ...workHistoryRoutes,
];
